import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

function ProtectedRoute({ children }) {
  const authRaw = localStorage.getItem("auth");
  const location = useLocation();

  const auth = authRaw ? JSON.parse(authRaw) : null;

  if (!auth || !auth.token) {
    // not logged in → send to login page
    return <Navigate to="/authentication/sign-in" replace state={{ from: location }} />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
